import { afterDomUpdate } from "./util";
import { DataManager } from "./data-manager";

export class Synchronizer {

   constructor(dm) {
      this.dm = dm;
   }

   async saveData(data, progress) {

      const receivedData = data.get;
      const sentData = data.set;

      let cntItems = Object.keys(receivedData).length;
      let cnt = 0;

      let t = Date.now();

      progress.setValue(0, 0, 'Speichere Daten ...');

      if (receivedData.hasOwnProperty('sysData')) {
         cnt++;
         if (receivedData.sysData.hasOwnProperty('courses'))          await this.saveCourses(receivedData.sysData.courses);
         if (receivedData.sysData.hasOwnProperty('years'))            await this.saveYears(receivedData.sysData.years);
         if (receivedData.sysData.hasOwnProperty('classes'))          await this.saveClasses(receivedData.sysData.classes);
         if (receivedData.sysData.hasOwnProperty('users'))            await this.saveUsers(receivedData.sysData.users);
         if (receivedData.sysData.hasOwnProperty('subjects'))         await this.saveSubjects(receivedData.sysData.subjects);
         if (receivedData.sysData.hasOwnProperty('resources'))        await this.saveResources(receivedData.sysData.resources);
         if (receivedData.sysData.hasOwnProperty('rooms'))            await this.saveRooms(receivedData.sysData.rooms);
         if (receivedData.sysData.hasOwnProperty('appointmentTypes')) await this.saveAppointmentTypes(receivedData.sysData.appointmentTypes);
         if (receivedData.sysData.hasOwnProperty('userGroups'))       await this.saveUserGroups(receivedData.sysData.userGroups);
      }
      progress.setValue((cnt / cntItems) * 100);

      if (receivedData.hasOwnProperty('timetable'))            { cnt++; await this.saveTimetable(receivedData.timetable); }
      progress.setValue((cnt / cntItems) * 100);

      if (receivedData.hasOwnProperty('watches'))            { cnt++; await this.saveWatches(receivedData.watches); }
      progress.setValue((cnt / cntItems) * 100);


      if (receivedData.hasOwnProperty('ticker'))   { cnt++; await this.saveTicker(receivedData.ticker); }
      progress.setValue((cnt / cntItems) * 100);

      if (receivedData.hasOwnProperty('themes'))   { cnt++; await this.saveThemes(receivedData.themes); }
      progress.setValue((cnt / cntItems) * 100);

      if (receivedData.hasOwnProperty('themeChoices'))   { cnt++; await this.saveThemeChoices(receivedData.themeChoices); }
      progress.setValue((cnt / cntItems) * 100);


      if (receivedData.hasOwnProperty('pupilNoteTemplates'))   { cnt++; await this.savePupilNoteTemplates(receivedData.pupilNoteTemplates); }
      progress.setValue((cnt / cntItems) * 100);

      cnt++;
      await this.saveClassRegister(receivedData.classRegister, sentData.classRegister);
      progress.setValue((cnt / cntItems) * 100);

      cnt++;
      await this.saveClassNotes(receivedData.classNotes, sentData.classNotes);
      progress.setValue((cnt / cntItems) * 100);

      //cnt++;
      //await this.saveAbsences(receivedData.absences, sentData.absences);
      //progress.setValue((cnt / cntItems) * 100);

      cnt++;
      await this.saveAppointments(receivedData.appointment, sentData.appointment);
      progress.setValue((cnt / cntItems) * 100);

      if (receivedData.hasOwnProperty('resource-reservation')) { cnt++; await this.saveResourceReservations(receivedData['resource-reservation']); }
      progress.setValue((cnt / cntItems) * 100);
      if (receivedData.hasOwnProperty('substitutions'))        { cnt++; await this.saveSubstitutions(receivedData.substitutions); }
      progress.setValue((cnt / cntItems) * 100);
      if (receivedData.hasOwnProperty('tagesplaene'))          { cnt++; await this.saveTagesplaene(receivedData.tagesplaene); }
      progress.setValue((cnt / cntItems) * 100);
      if (receivedData.hasOwnProperty('userClientSettings'))   {
         cnt++;
         try {
            if (receivedData.userClientSettings.data.length === 0) receivedData.userClientSettings.data = '{}';
            this.dm.clientSettings.load({ lastUpdate: receivedData.userClientSettings.lastUpdate, data: JSON.parse(receivedData.userClientSettings.data) });
         }
         catch (e) {
            console.error(e);
            this.dm.clientSettings.load({ lastUpdate: 0, data: {} });
         }

      }
      progress.setValue((cnt / cntItems) * 100);

      logger.message("sync: " + (Date.now()-t) + 's');

   }

   async saveUsers(data) {

      try {
         await db.users.clear();
         await db.users.bulkPut(data);
         await this.dm.cacheUsers(true);
         await this.dm.cachePupils(true);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveUsers: ' + e.message);
      }
   }

   /*
   async saveMyCourses(data) {
      await db.myCourses.clear();
      await db.myCourses.bulkPut(data);
   }
   */

   async saveCourses(data) {
      try {
         await db.courses.clear();
         await db.courses.bulkPut(data);
         await this.dm.cacheCourses(true);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveCourses: ' + e.message);
      }
   }


   async saveYears(data) {
      try {      
         await db.years.clear();
         data.map(item => item.isCurrent = item.isCurrent ? 1 : 0);
         await db.years.bulkPut(data);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveYears: ' + e.message);
      }
   }

   async saveClasses(data) {
      try {
         await db.classes.clear();
         await db.classes.bulkPut(data);
         await this.dm.cacheClasses(true);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveClasses: ' + e.message);
      }
   }

   async saveRooms(data) {
      try {
         await db.rooms.clear();
         await db.rooms.bulkPut(data);
         await this.dm.cacheRooms(true);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveRooms: ' + e.message);
      }
   }

   async saveSubjects(data) {
      try {
         await db.subjects.clear();
         await db.subjects.bulkPut(data);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveSubjects: ' + e.message);
      }
   }

   async saveUserGroups(data) {
      try {
         await db.userGroups.clear();
         await db.userGroups.bulkPut(data);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveUserGroups: ' + e.message);
      }
   }

   async saveResources(data) {
      try {
         await db.resources.clear();
         await db.resources.bulkPut(data);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveResources: ' + e.message);
      }
   }

   async saveAppointmentTypes(data) {
      try {
         let sort = { 1:0, 5:1, 3:2, 7:3, 4:4, 2:5, 6:6 };
         data.map(item => { item.sort = sort[item.id]; });
         await db.appointmentTypes.clear();
         await db.appointmentTypes.bulkPut(data);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveAppointmentTypes: ' + e.message);
      }
   }

   async saveTimetable(data) {
      try {
         await db.timetable.clear();
         await db.timetable.bulkPut(data.items);
         await this.dm.cacheTimetable(true);
         localStorage.setItem('lastUpdateTimetable', data.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveTimetable: ' + e.message);
      }
   }

   async saveWatches(data) {
      try {
         await db.watches.clear();
         await db.watches.bulkPut(data.items);
         //await this.dm.cacheTimetable(true);
         localStorage.setItem('lastUpdateWatches', data.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveWatches: ' + e.message);
      }
   }

   async saveTicker(data) {
      try {
         await this.dm.setKeyValueData('ticker', data.update);
         localStorage.setItem('lastUpdateTicker', data.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveTicker: ' + e.message);
      }
   }

   async saveThemes(data) {
      try {
         await db.themes.bulkPut(data.items);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveThemes: ' + e.message);
      }
   }

   async saveThemeChoices(data) {
      try {
         await this.dm.setKeyValueData('themeChoices', data.items);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveThemeChoices: ' + e.message);
      }
   }


   async savePupilNoteTemplates(data) {
      try {
         await this.dm.setKeyValueData('pupilNoteTemplates', JSON.stringify(data.items));
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.savePupilNoteTemplates: ' + e.message);
      }
   }   

   async saveAppointments(receivedData, sentData) {

      try {
         let t = Date.now();

         if (receivedData) {
            receivedData.update = receivedData.update.map(app => { return {
               id:               app.id,
               typeId:           app.id_type,
               yearId:           app.id_year,
               dateFrom:         app.date_from,
               dateTo:           app.date_to,
               creator:          app.creator,
               classes:          app.classes,
               lastModifier:     app.last_modifier,
               creationTime:     app.creation_time,
               lastModTime:      app.last_mod_time,
               title:            app.title,
               note:             app.note,
               noteSens:         app.note_sens,
               notePublic:       app.note_public,
               isPublic:         app.isPublic,
               permissionGroups: app.permission_groups,
               owners:           app.owners,
               editable:         app.editable,
               deletable:        app.deletable,
               allowedTo:        app.allowedTo
            }});
         }
         // metaData laden
         let metaData = await this.dm.getKeyValueData('appointments') || { idMap: {}, yearId: null };
         
         await this.saveSyncItems(db.appointments, receivedData, sentData, metaData);
         await this.dm.setKeyValueData('appointments', metaData);
         //logger.message("appointments: " + (Date.now()-t) + 's');
         if (receivedData) localStorage.setItem('lastUpdateAppointments', receivedData.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveAppointments: ' + e.message);
      }

   }


   async saveClassRegister(receivedData, sentData) {

      try {
         let t = Date.now();

         // metaData laden
         let metaData = await this.dm.getKeyValueData('classRegister') || { idMap: {}, yearId: null };

         // Alle Einträge vorbereiten
         if (receivedData) {
            receivedData.update.map(item => {
               this.dm.setupClassRegisterItem(item);
            });
         }

         await this.saveSyncItems(db.classRegister, receivedData, sentData, metaData);

         await this.dm.setKeyValueData('classRegister', metaData);
         //logger.message("classRegister: " + (Date.now()-t) + 's');

         if (receivedData) localStorage.setItem('lastUpdateClassRegister', receivedData.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveClassRegister: ' + e.message);
      }

   }

   async saveClassNotes(receivedData, sentData) {

      try {
         let t = Date.now();

         let metaData = await this.dm.getKeyValueData('classNotes') || { idMap: {}, yearId: null };

         await this.saveSyncItems(db.classNotes, receivedData, sentData, metaData);
         await this.dm.setKeyValueData('classNotes', metaData);
         if (receivedData) localStorage.setItem('lastUpdateClassNotes', receivedData.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveClassNotes: ' + e.message);
      }

   }
   /*
   async saveAbsences(receivedData, sentData) {

      try {
         let t = Date.now();
         
         let metaData = await this.dm.getKeyValueData('dayAbsences') || { idMap: {}, yearId: null };

         if (receivedData) {
            for (let abs of receivedData.update) {
               this.dm.setupDayAbsenceItem(abs);
            }
         }

         //await this.saveSyncItems(db.absences, receivedData, sentData, metaData);
         await this.dm.setKeyValueData('dayAbsences', metaData);
         if (receivedData) localStorage.setItem('lastUpdateAbsences', receivedData.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveAbsences: ' + e.message);
      }

   }
   */  

   async saveSyncItems(dbTable, receivedData, sentData, metaData) {

      if (receivedData) {
         
         // syncStatus und localId aller Elemente zurücksetzen
         receivedData.update.map(item => {
            item.syncStatus = '';
            if (item.localId === 0) delete item.localId;
         });

         
         // alle Einträge nicht aktueller Schuljahre löschen

         if (metaData.yearId !== receivedData.currentYear) {
            await dbTable.where('yearId').notEqual(receivedData.currentYear).delete();
            metaData.yearId = receivedData.currentYear;
         }
         
         // Wenn noch keine Einträge in der Datenbank gespeichert sind: direkt einfügen und IdMap speichern
         if (await dbTable.count() === 0 && receivedData.update.length) {
            let keys = await dbTable.bulkAdd(receivedData.update, {allKeys: true});
            metaData.idMap = {};
            for (let i=0; i<receivedData.update.length; ++i) metaData.idMap[receivedData.update[i].id] = keys[i];
         }
         else {
            // Zu löschende Einräge aus der Datenbank und aus der IdMap entfernen
            if (receivedData && receivedData.delete && receivedData.delete.length) {
               await dbTable.where('id').anyOf(receivedData.delete).delete();
               for (let item of receivedData.delete) delete metaData.idMap[item.id];
            }

            // Die lokalen IDs aller vorhandenen Einträge aus der IdMap eintragen,
            // außerdem die vom Server zurückgegebnenen lokalen IDs der neu erstellten Einträge eintragen,
            // die Datensätze speichern und die IdMap aktualisieren.
            if (receivedData.update.length) {
               for (let classReg of receivedData.update) {
                  if (metaData.idMap.hasOwnProperty(classReg.id)) classReg.localId = metaData.idMap[classReg.id];
                  else if (sentData && sentData.new && sentData.new.hasOwnProperty(classReg.id)) classReg.localId = sentData.new[classReg.id];
               }
               let keys = await dbTable.bulkPut(receivedData.update, {allKeys: true});
               for (let i=0; i<receivedData.update.length; ++i) metaData.idMap[receivedData.update[i].id] = keys[i];
            }

         }

      }

      // Fehlerbehandlung
      if (sentData && sentData.error) {
         for (const item of sentData.error) {
            await dbTable.update(item.localId, {syncStatus: item.syncStatus, errorMessage: item.errorMessage });
         }
      }

   }


   async saveResourceReservations(data) {
      try {
         for (let key in data.items) {
            // alle Termine nicht aktueller Schuljahre löschen
            let year = parseInt(key);
            await db.resourceReservations.filter(rsv => {
               return rsv.year === year && !data.items[key].ids.includes(rsv.id);
            }).delete();

            data.items[key].updates.map(rsv => { rsv.year = year });
            await db.resourceReservations.bulkPut(data.items[key].updates);
         }

         localStorage.setItem('lastUpdateResRsv', data.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveResourceReservations: ' + e.message);
      }

   }

   async saveSubstitutions(data) {

      try {
         let subst = data.items.map(item => {
            if (item.classes) item.classSortKey = item.classes[0].replace(/^(\d[^\d])/, '0$1');
            else item.classSortKey = '';
            if (item.rooms)   item.roomSortKey = item.rooms[0].replace(/^(\d[^\d])/, '0$1');
            else item.roomSortKey = '';
         });

         await db.substitutions.clear();
         await db.substitutions.bulkPut(data.items);
         localStorage.setItem('lastUpdateSubstitutions', data.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveSubstitutions: ' + e.message);
      }

   }

   async saveTagesplaene(serverTpl) {

      try {
         // alle Tagespläne löschen, die im Update nicht vorkommen oder die im Update vorkommen, aber neue Daten enthalten
         await db.tagesplaene.filter(oldTpl => {
            for (const tpl of serverTpl.items) {
               if (oldTpl.date === tpl.date && oldTpl.page === tpl.page) {
                  if (tpl.data != '#') return true;
                  else return false;
               }
            }
            return true;
         }).delete();

         // nur die Tagespläne aktualisieren, deren Wert des Attributes 'data' nicht '#' ist.
         let newData = serverTpl.items.filter(item => item.data !== '#');
         if (newData.length > 0) await db.tagesplaene.bulkPut(newData);
         localStorage.setItem('lastUpdateTagesplaene', serverTpl.lastUpdate);
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveTagesplaene: ' + e.message);
      }

   }

   async getData() {

      const classRegUpdate = await db.classRegister.where({syncStatus: 'update'}).toArray();
      const classRegDelete = await db.classRegister.where({syncStatus: 'delete'}).toArray();

      const classNotesUpdate = await db.classNotes.where({syncStatus: 'update'}).toArray();
      const classNotesDelete = await db.classNotes.where({syncStatus: 'delete'}).toArray();

      const userClientSettings = this.dm.clientSettings.exportData();
      const currentTheme = await this.dm.getCurrentTheme();
      userClientSettings.themeId = currentTheme ? currentTheme.id : 0;

      return {
         classRegister: { update: classRegUpdate,   delete: classRegDelete.map(item => item.id) },
         classNotes:    { update: classNotesUpdate, delete: classNotesDelete.map(item => item.id) },
         userClientSettings
      }
      
   }

}
